import { getObjectKeys, isNullish } from "@/helpers/common";

import type { UtmParameterSet } from "@/models/applications";

export const formatUtmSet = (set: UtmParameterSet): string => {
  return getObjectKeys(set).reduce((result, param) => {
    if (set[param] === "" || isNullish(set[param]) || param === "id") {
      return result;
    }

    const divider = result.length ? " | " : "";
    return result + divider + `${param}=${set[param]}`;
  }, "");
};
